import {
  CircleAlert,
  Flag,
  Home,
  Settings2,
  SlidersHorizontal,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  id: string
  label: string
  url: string
  icon: LucideIcon
  hidden?: boolean
  children?: NavItem[]
  expandable?: boolean
  defaultExpanded?: boolean
}

export interface NavGroup {
  id: string
  header?: string
  children: NavItem[]
}

const navigation: NavGroup[] = [
  {
    id: 'main-nav',
    children: [
      {
        id: 'home',
        label: 'Home',
        icon: Home,
        url: '/',
      },
      {
        id: 'control-center',
        label: 'Control Center',
        icon: SlidersHorizontal,
        url: '/control-center',
        expandable: true,
        defaultExpanded: true,
        children: [
          {
            id: 'alerts',
            label: 'Alerts',
            icon: CircleAlert,
            url: '/control-center/alerts',
          },
          {
            id: 'feature-flags',
            label: 'Feature Flags',
            icon: Flag,
            url: '/control-center/feature-flags',
          },
          {
            id: 'configuration',
            label: 'Configuration',
            icon: Settings2,
            url: '/control-center/configuration',
            // shown only to SUPER_ADMIN — filtered in NavigationSidebar
          },
        ],
      },
    ],
  },
]

export default navigation
